var map = {
	"./SpeechAndPrizeGivingDay1.jpeg": 7991,
	"./SpeechAndPrizeGivingDay10.jpeg": 1201,
	"./SpeechAndPrizeGivingDay11.jpeg": 7706,
	"./SpeechAndPrizeGivingDay12.jpeg": 9639,
	"./SpeechAndPrizeGivingDay13.jpeg": 3856,
	"./SpeechAndPrizeGivingDay14.jpeg": 2293,
	"./SpeechAndPrizeGivingDay2.jpeg": 298,
	"./SpeechAndPrizeGivingDay3.jpeg": 6993,
	"./SpeechAndPrizeGivingDay4.jpeg": 4708,
	"./SpeechAndPrizeGivingDay5.jpeg": 6875,
	"./SpeechAndPrizeGivingDay6.jpeg": 3582,
	"./SpeechAndPrizeGivingDay7.jpeg": 6917,
	"./SpeechAndPrizeGivingDay8.jpeg": 8296,
	"./SpeechAndPrizeGivingDay9.jpeg": 5887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4587;